import { authService } from '@simwood/nv-react-components';
import store from '.';
import { restAPIBase } from '../../shared/helpers/nvFetch';
import * as platformApi from '../../shared/helpers/platformApi';
import { setActiveCustomerAndFetchLinkedUsers } from '../../shared/reducers/client';
import {
  externalLoginFinished,
  tokenReceived,
} from '../../shared/reducers/user';
import { launch, showWindow, unload } from '../helpers/partnerCrm';
import { diallerNumberSet, openChangelog } from '../reducers/app';
import { openPreferences } from '../reducers/audio';
import { answerCall, endCall } from '../reducers/calls';
import { logout } from '../reducers/user';

export const initStoreListeners = () => {
  if (window.electronAPI && window.electronAPI.onSelectTeam) {
    window.electronAPI.onSelectTeam((teamId: any) => {
      store.dispatch(setActiveCustomerAndFetchLinkedUsers(teamId));
    });

    window.electronAPI.onLogOut(() => {
      store.dispatch(logout());
    });

    window.electronAPI.onPreferences(() => {
      store.dispatch(openPreferences());
    });

    window.electronAPI.onAnswerCall((callId: any) => {
      store.dispatch(answerCall(callId));
    });

    window.electronAPI.onHangUpCall((callId: any) => {
      store.dispatch(endCall(callId));
    });

    window.electronAPI.onVcrmToggle((connect: boolean) => {
      if (connect) {
        const {
          vcrm: { launchToken },
          client: { activeCustomer },
        } = store.getState();
        if (!launchToken) {
          return;
        }
        launch(launchToken, activeCustomer?.country);
      } else {
        unload();
      }
    });

    window.electronAPI.onVcrmConfigure(() => {
      showWindow();
    });

    window.electronAPI.onDial((number: string) => {
      store.dispatch(diallerNumberSet({ number }));
    });

    window.electronAPI.onShowChangelog(() => {
      store.dispatch(openChangelog());
    });

    window.electronAPI.onShutdown(async () => {
      try {
        await unload();
      } finally {
        platformApi.shutdownComplete();
      }
    });

    window.electronAPI.onOAuthComplete((code: string, state?: string) => {
      authService.handleOauthCallback(
        restAPIBase(),
        code,
        (_params, accessToken, expires) => {
          if (store.getState().user.isLoggingInExternally) {
            store.dispatch(externalLoginFinished());
            store.dispatch(tokenReceived({ accessToken, expires }));
          }
        },
        (err) => {
          console.error(err);
          store.dispatch(externalLoginFinished());
        },
        undefined,
        state,
      );
    });
  }
};
